export const KubernetesApplicationQuotaDefaults = {
  CpuLimit: 0.1,
  CpuRequest: 0.1,
  MemoryLimit: 128, // MB
  MemoryRequest: 128, // MB
};

export const KubernetesPortainerApplicationStackNameLabel = 'io.portainer.kubernetes.application.stack';

export const KubernetesPortainerApplicationStackIdLabel = 'io.portainer.kubernetes.application.stackid';

export const KubernetesPortainerApplicationKindLabel = 'io.portainer.kubernetes.application.kind';

export const KubernetesPortainerApplicationNameLabel = 'io.portainer.kubernetes.application.name';

export const KubernetesPortainerApplicationOwnerLabel = 'io.portainer.kubernetes.application.owner';

export const KubernetesPortainerApplicationNote = 'io.portainer.kubernetes.application.note';
